import { Outlet } from "react-router-dom";
import { Navbar5 } from "./navbars";
import { Footer4 } from "./footer";
import BackToTop from "./BackToTop"
import { Suspense } from 'react';
import { Spinner } from 'react-bootstrap';

export default function MainLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar5 navClass="sticky-top" />
      <main className="flex-grow">
        <Outlet />
      </main>
      

      <Suspense fallback={<div className="text-center p-5"><Spinner animation="border" /></div>}>
          <Footer4 />
      </Suspense>
            
      <BackToTop/>
    </div>
  );
}